import Http from '../Http';

export class PrecioCombustibleService {
  static async obtenerLista(page = 0, limit = 15, filters: Record<string, string> = {}, orderBy = '', order = 'asc') {
    const params = new URLSearchParams();
    params.set('p', page.toString());
    params.set('l', limit.toString());
    
    if (Object.keys(filters).length) {
      params.set('q', JSON.stringify(filters));
    }
    if (orderBy) {
      params.set('orderBy', orderBy);
      params.set('order', order);
    }

    try {
      const res = await Http.get(`combustible-precio/filter?${params.toString()}`);
      return res?.data?.rows || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  static async eliminar(row: any) {
    try {
      const res = await Http.post(`combustible-precio/delete`, row);
      return Boolean(res && !res.error);
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  static async obtenerPorId(id: string | number) {
    try {
      const res = await Http.get(`combustible-precio/one/${id}`);
      return res?.data ?? null;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  static async guardar(data: any) {
    try {
      const res = await Http.post(`combustible-precio/save`, data);
      return res || { error: true, errMsg: 'Error al guardar Actualización de Precio de Combustible' };
    } catch (e) {
      console.error(e);
      return { error: true, errMsg: 'Error al guardar Actualización de Precio de Combustible' };
    }
  }
}
